import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

export interface LoyaltyRewardsPage {
    gridContainer?: GridContainerProps;
    gridContainermodal?: GridContainerProps;
    leftColumnWrapper?: GridContainerProps;
    leftColumnContainer?: GridContainerProps;
    rightColumnWrapper?: GridContainerProps;
    rightColumnContainer?: GridContainerProps;
    loyaltyContainer?: GridContainerProps;
    GridItem?: InjectableCss;
    GridItemModalTitle?: InjectableCss;
    leftColumnModalGrid?: InjectableCss;
    titleGridItemModal?: InjectableCss;
    loyaltyLabelTextModal?: InjectableCss;
    loyaltyPendPointsText?: InjectableCss;
    loyaltyValueTextModal?: InjectableCss;
    circularProgressBarModal?: InjectableCss;
    loyaltygoalValueTextModal?: InjectableCss;
    loyaltyAvailPointsText?: InjectableCss;
    loyaltyTitleTextModal?: InjectableCss;
    loyaltyTitledateModal?: InjectableCss;
    loyaltyValueTextpercentage?: InjectableCss;
    hideElementsMob?: InjectableCss;
    loyaltyTotalSpend?: InjectableCss;
    loyaltyRemainingSpend?: InjectableCss;
    loyaltyProgressModal?: InjectableCss;
    rewardsInfoIconNotes?: InjectableCss;
    rewardsInfoIconhide?: InjectableCss;
    rewardsInfoIconPending?: InjectableCss;
    browseAndRedeem?: InjectableCss;
    browseAndRedeemModal?: InjectableCss;
    GridItemLogo?: InjectableCss;
    loyaltyGridItem?: InjectableCss;
    progressBar?: InjectableCss;
    progressBarModel?: InjectableCss;
    loyaltyLabelgrid?: InjectableCss;
    loyaltyLabelgridModel?: InjectableCss;
    loyaltybtngrid?: InjectableCss;
    loyaltyRedeemBtn?: InjectableCss;
    loyaltyRedeemBtnModal?: InjectableCss;
    loyaltyTitleText?: TypographyProps;
    loyaltyTitledate?: TypographyProps;
    loyaltyBorder?: TypographyProps;
    titleGridItem?: TypographyProps;
    subtitleGridItem?: TypographyProps;
    loyaltyLabelText?: TypographyProps;
    loyaltyValueText?: TypographyProps;
    loyaltyNotes?: TypographyProps;
    circularProgressBar?: TypographyProps;
    loyaltyDetailGrid?: InjectableCss;
    loyaltySeedetailBtn?: InjectableCss;
    LoyaltyRewardsStyle?: LoyaltyRewardsPage;
    loyaltyRewardsPopup?: LoyaltyRewardsPage;
    leftColumnWrapperModal?: GridContainerProps;
    leftColumnModal?: GridContainerProps;
    hideElements?: InjectableCss;
    loyaltyContainerModal?: GridContainerProps;
    infoMsgGridItem? : InjectableCss;
    loyaltymypointsContainer?: InjectableCss;
    rightColumnAppsend?:InjectableCss;
    browseAndRedeemModalactivate?: InjectableCss;
}

export const loyaltyRewards: LoyaltyRewardsPage | undefined = {
    LoyaltyRewardsStyle: {
        
        browseAndRedeemModalactivate: {
            css: css`
                position: absolute;
                bottom: 0px;

                border-top: 1px solid rgb(187, 187, 187);
                background: rgb(247, 247, 247);

                margin-top: 65px !important;
                padding: 25px 20px 30px !important;
            `,
        },
        gridContainer: {
            css: css`
                background-image: linear-gradient(#ffffff, #e8eef5);
                margin: 60px auto 3px;
                padding: 20px 40px; 
                border-radius: 4px;
                //padding-bottom: 24px;

                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [
                        css`
                            padding: 30px 15px 20px 15px;
                            max-width: 100%;
                            position: relative;
                            margin-top: 40px;
                            margin-bottom: 3px;
                            background: linear-gradient(180deg, white 40%, #E8EEF5 100%);
                            `,
                        null,
                        css`
                            padding: 30px 30px 20px 30px; 
                            `,


                    ],);
                }}  
                    > ${GridOffset}{
                        ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` position: relative;
                            margin: 0;
                            width: 100%; `,], "max",);
                }} 

                        > ${GridItemStyle} {
                            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` padding:0px; `, null, css` padding:0px; `,],);
                }}  
                                &:first-child{
                                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css`display: flex;
                                        margin-bottom: 20px;
                                        justify-content: center; `, null, css`margin-bottom: 20px;`,],);
                }}  
                                }
                            }
                    }
            `,
        },
        GridItemLogo: {
            css: css`
            max-width: 100%;
            padding: 0px;
            padding-bottom: 30px;
            position: relative;
            width: 100%;
            justify-content: center;
            display: flex;
            &:after{
                content: "";
                width: 100%;
                position: absolute;
                border-bottom: 1px solid #bbb;
                bottom: 0;
                height: auto;
            }
            `,

        },
        GridItemModalTitle: {
            css: css`
            max-width: 100%;
            padding: 0px;
            padding-bottom: 20px;
            border-bottom: 1px solid #bbb;
            margin-bottom: 20pxs;
            position: relative;
            width: 100%;
            justify-content: center;
            display:flex;
            flex-direction:column;
            align-items: center;
            `,
        },
        loyaltyTitleTextModal: {
            css: css`
            color: #2D2926;
            font-size: 24px;
            font-weight: 700;
            line-height:normal;
            margin: 0px;
            white-space: nowrap;
            `,
        },
        loyaltyTitledateModal: {
            css: css`
            color: #2D2926;
            font-size: 12px;
            font-weight: 400;
            margin-top: 5px;
            `,
        },
        gridContainermodal: {
            css: css`
                padding: 15px 20px 0 20px;
                background-image: none;
                background-color: #fff;
                margin-bottom: 0;
                > ${GridOffset}{
                    flex-direction: column;
                    width: 100%;
                    margin: 0px;
                    align-items: center;
                    > ${GridItemStyle} {
                       
                        }
                }
                `,
        },
        leftColumnWrapper: {
            css: css`
            display: block;
            position: relative;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, null, css` max-width: 38%;
                flex-basis: 38%;
                padding: 15px 0;`,], "min",);
                }} 
                ${GridOffset}{
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` width: 100%; max-width:100%;`,], "max",);
                }}  
                }

            `,
        },

        rightColumnWrapper: {
            css: css`
            display: block;
            position: relative;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, null, css` max-width: 62%;flex-basis: 62%;`,], "min",);
                }} 
            `,
        },

        rightColumnContainer: {
            css: css`  
               >  ${GridOffset} {
                    justify-content: center;
                    margin: 0;
                    width: 100%;
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` width: 100%; max-width:100%;`,], "max",);
                }}  
                    > ${GridItemStyle} {
                        margin: 0 10px;
                        padding: 20px 10px;
                        border-radius: 4px;
                        max-width: calc(32% - 20px);
                        height: auto;
                        display: flex;
                        flex-direction: column;  
                        ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` max-width: 234px;margin: 20px 0px; `, null, css`max-width: calc(33% - 9px);margin: 0px 4.5px;`,],);
                }}  
                  
                        > ${TypographyStyle} {
                            text-align: center;
                            font-weight: 700;
                            //margin-bottom: 5px;
                            &:first-child {
                                flex: 1;
                                display: flex;
                                flex-Direction: column;
                                line-height: 24px;
                            }
                            &:nth-child(2) {
                                line-height: 20px;
                                font-size:14px;
                                font-weight: 400;
                                strong {
                                    margin: 0 3.2px;
                                }
                            }
                            &:nth-child(3) {
                                margin-top: 10px;
                                margin-bottom: 8px;
                                line-height: 34px;
                            }
                            &:last-child{                               
                                line-height: 20px;
                                font-size:14px;
                            }
                            

                        }
                        button {
                            color: #006ae3;
                            font-size: 14px;
                            margin: auto;
                            font-weight: 700;
                            line-height:20px;
                        }
                    }
                }
            `,
        },

        leftColumnContainer: {
            css: css`  
               ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` margin-bottom:40px; `, null, css` border-right: 0;margin-bottom:20px; `,],);
                }}
               >  ${GridOffset} {
                    margin: 0;
                    width: 100%;
                    justify-content: center;
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` width:100%;max-width:100%; `,], "max",);
                }}  
                    
                    &:after {
                        content: "";
                        position: absolute;
                        border-right: 1px solid #bbb;
                        right: 0;
                        top: 30px;
                        height: calc(100% - 35px);
                        ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` border-right: 0;width: 100%; `,], "max",);
                }}
                    }
                    
                    > ${GridItemStyle} {
                        justify-content: center;
                        display: flex;
                        flex-direction: column;
                        &:first-child{
                            justify-content: center;
                            align-items: center;
                            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` flex-direction: row; margin-bottom:20px;`,], "max",);
                }}
                          
                > ${GridItemStyle} {
                    width: 100%;
                    max-width: 100%;
                    padding: 0;
                    &:first-child{
                        > ${TypographyStyle} {
                            color: #2D2926;
                            text-align: center;
                            line-height: 24px;

                            &:first-child{
                                font-size: 16px;
                                font-weight: 400;
                                margin-bottom: 6px; 

                            }
                            &:last-child{
                                font-size: 24px;
                                font-weight: 700;
                                margin-bottom: 20px;    
                                line-height: 34px;
                                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css`margin-bottom: 0px; `,], "max",);
                }} 
                            }
                        }

                    }
                    &:last-child{
                        > ${TypographyStyle} {
                            color: #666;
                            text-align: center;
                            line-height: 24px;
                            
                            &:first-child{
                                font-size: 16px;
                                font-weight: 400;
                                margin-bottom: 6px; 
                            }
                            &:last-child{
                                margin-bottom: 0px;    
                                line-height: 34px;
                                font-size: 24px;
                                font-weight: 700;
                            }
                        }

                    }

                }
                        }

                        > ${TypographyStyle} {
                            color: ${getColor("text.main")};
                            text-align: center;
                            line-height: 24px;
                            
                        }
                    }
                }
            `,
        },
        loyaltyBorder: {
            css: css`
                border-bottom: 1px solid #bbb;
                width: 100%;
                margin: 6px 15px 6px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` margin: 20px 15px 20px; `, null, css`margin:20px 0px;`,],);
                }}  
            `,
        },
        loyaltyTitleText: {
            variant: "h2",
            size: 22,
            weight: 700,
            css: css`
            color: #002856;
            text-align: center;
            margin: 0;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` font-size:20px;line-height:28px; `,], "max",);
                }}  
            `,

        },
        loyaltyTitledate: {
            size: 14,
            weight: 400,
            css: css`
            color: ${getColor("text.main")};
            text-align: center;
            line-height: 23px;
            `,
        },
        titleGridItem: {
            variant: "h4",
            size: 20,
            weight: 700,
            css: css`
            color: #002856;
            text-align: center;
            margin: 0;
            line-height: 26px;
            `,
        },
        subtitleGridItem: {
            variant: "p",
            size: 14,
            weight: 400,
            css: css`
            color: ${getColor("text.main")};
            text-align: center;
            margin: 0 0 20px;
            line-height: 23px;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` margin: 0px;font-size:12px; `,], "max",);
                }} 

            strong {
                margin: 0 3.2px;
            }
            `,
        },
        progressBar: {
            css: css`
            position: relative;
            width: 180px;
            height: 180px;
            float: left;
            padding: 0;
            ${GridItemStyle} {
                position: absolute;
                text-align: center;
                left: 50%;
                top: 55%;
                transform: translate(-50%, -50%);

                > ${TypographyStyle} {
                    color: #002856;
                    line-height: normal;
                    &:nth-child(even) {
                        margin-bottom: 18px; 
                        font-size: 22px;        
                    }
                    &:nth-child(odd) {
                        font-size:14px;
                        ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` font-size:16px; `,], "max",);
                }} 
                    }
                    &:last-child {
                        margin-bottom: 0;
                        
                    }
                }
            }
            `,
        },
        progressBarModel: {
            css: css`
           width:160px;
           height:160px;
           ${GridItemStyle}  {
                position: absolute;                          
                top: 20px;
                right: 8px;
                padding: 10px 0px;
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, css` right: 20px; `,],"max",); 
                }}

                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` right: 0%`,],"max",); 
                }}
           }
        `,
        },
        circularProgressBarModal: {
            css: css`
                position: absolute;
                text-align: center;
                left: calc(50% - 8px);
                top: 50%;
                transform: translate(-50%, -50%);
                width:160px;
                height:160px;
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, css` left: calc(50% - 20px); `,],"max",); 
                }}
                .layaltyRewards{
                    width:160px;
                    height:160px;
                }
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` left: 50%`,],"max",); 
                }}
            }`,
        },
        circularProgressBar: {
            css: css`
                position: absolute;
                text-align: center;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }`,
        },
        GridItem: {
            css: css`
            display: block;
            width: 100%;
            position: relative;
            
            
            > ${TypographyStyle} {
                display: block;
                width: 100%;
            }
            `,
        },
        infoMsgGridItem: {
            css: css`
            display: block;
            width: 100%;
            position: relative;
            max-width:75%!important;
            flex-basis:75%!important;
            
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [css` max-width:94.5%!important;flex-basis:94.5%!important;`,  
				css` max-width:94.5%!important;flex-basis:94.5%!important;`, 
				css` max-width:97%!important;flex-basis:97%!important;`,
			],); 
            }}
            
            > ${TypographyStyle} {
                display: block;
                width: 100%;
            }
            `,
        },
        loyaltyLabelText: {
            size: 16,
            weight: 400,
            css: css`
            image.png
            `,
        },
        loyaltyValueText: {
            size: 24,
            weight: 700,
            css: css`
            image.png
            `,
        },
        loyaltyValueTextpercentage: {
            css: css`
            &:after{
                content: '%';
                font-size: 14px;
                font-weight: 400;
            }
            `,
        },
        loyaltyNotes: {
            size: 12,
            weight: 700,
            css: css`
            color: #666;
            margin-left:28px;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` margin-top: 10px;    width: calc(100% - 10px) !important; `, null, css`margin-top: 20px;`],);
                }}  
            &:last-child {
                font-size: 11px;
                font-weight: 400;
                margin-top: 13px;
                line-height:normal;
            }
            `,
        },
        loyaltyGridItem: {
            css: css`
            display: block;
            background: #fff;
            margin: 30px;

            > ${TypographyStyle} {
                display: block;
                width: 100%;
            }
            `,
        },
        loyaltyContainer: {
            css: css`
                background: linear-gradient(180deg,#ebf1f7 17%,#e8eef5 100%);
                border-radius: 4px;
                justify-content: center;
                align-items: flex-start;
                display: flex;
                margin: 3px auto 40px;
                padding: 22px 0;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css`     
                    max-width: 100%;
                    width: 100%;
                    margin: 0;
                    padding: 16px 15px 30px 15px; 
                    `,
                        css`
                    padding: 16px 15px 30px 15px; 
                    `,], "max",);
                }}

                >  ${GridOffset} {
                    margin: 0;
                    padding: 0;

                    > ${GridItemStyle} {
                        padding: 0;
                        justify-content: center;
                        align-items:center;
                        ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` flex-direction: column; `,], "max",);
                }}
                                                
                        > ${TypographyStyle} {
                            padding: 0;
                            margin: 0;
                            color: ${getColor("text.main")};
                            text-align: center;
                        }
                        ${GridItemStyle} {
                            &.loyaltymypoints {
                                margin-left: 0px;
                                padding: 0 60px 0 0;
                                margin-right: 60px;
                                position:relative;
                                flex-basis:auto;
                                text-align: center;
                               
                                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` margin-bottom:6px ; `, css` padding: 0;margin: 0px;margin-bottom:8px ; `,], "max",);
                }}
                                &:after {
                                    content: "";
                                    position: absolute;
                                    border-right: 1px solid #bbb;
                                    right: 0;
                                    top: 50%;
                                    height: 20px;
                                    transform: translate(0, -50%);
                                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` border-right: 0; `,], "max",);
                }}
                                }
                               
                                > ${TypographyStyle} {
                                    color: #002856;
                                    font-size: 20px;
                                    font-weight: 700;
                                    line-height: 28px;
                                    margin:0px;    
                                }   
                            }
                            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` display: block;width:100%;max-width:100%; `,], "max",);
                }}
                        }
                        
                        ${GridItemStyle} {
                            flex-basis:auto;
                            padding: 0;
                            > ${GridItemStyle} {
                                flex-basis:auto;
                                padding-right: 50px;
                                text-align: center;
                                align-items: baseline;
                                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css` padding-bottom: 10px;
                                    padding-right: 0px; `, 
                                null,
                                css` padding: 0 24px 0 0;flex-direction: column;
                                align-items: center; `,
                                css`flex-direction: column;align-items: center; `,],);
                }}

                                ${TypographyStyle} {
                                    &:first-child{
                                        color: #666666;
                                        font-size: 16px;
                                        font-weight: 400;
                                        line-height: 34px;
                                        padding-right: 6px;
                                        position:relative;
                                    }
                                }
                                ${TypographyStyle} {
                                    &:last-child {
                                        color: #666666;
                                        font-size: 24px;
                                        font-weight: 700;
                                        line-height: 34px;
                                         ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` display: block; `,], "max",);
                }}
                                    }
                                }   
                            }
                            ${GridItemStyle} {
                                &.mypointsavailable {
                                    ${TypographyStyle} {
                                        color: ${getColor("text.main")};
                                    }
                                }
                            }
                        }                           
                    }          
                }
            }                      
        `,
        },
        loyaltyLabelgrid: {
            css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right:50px;
               ${({ theme }) => { return breakpointMediaQueries(
                theme, [css``,  
				css``, 
				css`flex-direction: row !important; `,
                css` flex-direction: row !important; `,
                css``,
			],); 
            }}
            `,
        },
        loyaltyLabelgridModel: {
            css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right:50px;
               ${({ theme }) => { return breakpointMediaQueries(
                theme, [css``,  
				css``, 
				css`flex-direction: column; `,
                css` flex-direction: column; `,
                css``,
			],); 
            }}
            `,
        },
        loyaltybtngrid: {
            css: css`
            margin-right: 40px;
            justify-content: flex-start;
            align-items: center;
            display: flex;
            `,
        },
        loyaltyRedeemBtn: {
            css: css`
            width: 220px;
            justify-content: center;
            padding: 10px;
            border-radius: 4px;
            background-color: #006ae3;
            color:#fff;
            font-size: 16px;
            font-weight: 700;
            text-align:center; 
            height:40px;
            &:hover, &:focus {
                background-color: #002856;
            }  
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css `margin:0px auto;margin-top:10px;`, null, css`margin-top:20px;`,],);
            }}  
            `,
        },
        browseAndRedeem: {
            css: css`
            padding-top: 25px;
            padding-bottom: 35px;
            margin-top: 60px;          
            `,
        },
        browseAndRedeemModal: {
            css: css`
            padding-top: 25px;
            padding-bottom: 35px;
            margin-top: 65px;
            background: #f7f7f7;
            height: 90px
            border-top: 1px solid #bbb;    
            `,
        },
        loyaltyRedeemBtnModal: {
            css: css`
            width: 100%;
            justify-content: center;
            padding: 10px;
            border-radius: 4px;
            background-color: #006ae3;
            color:#fff;
            font-size: 16px;
            font-weight: 700;
            text-align:center; 
            height:40px;
            margin-top:0px;
            &:hover, &:focus {
                background-color: #002856;
            }    
            `,
        },
        loyaltyDetailGrid: {
            css: css`
            //display: none;
            .loyaltyseedetails a{
                font-family: Nunito Sans;
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #006ae3;
                text-transform: capitalize;
                margin-top: 30px;

            }
           
            }

            `,
        },

        //Modal
        leftColumnWrapperModal: {
            css: css`
            max-width: 100%;
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 35px 20px 30px 20px;
            background: linear-gradient(180deg,#fff 17%,#e8eef5 100%);
            border-radius: 4px;     
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` max-width: 100%; `,], "max",);
                }}     
            `,
        },
        hideElements: {
            css: css`
            display: none;
            `,
        },
        leftColumnModal: {
            css: css`             
               >  ${GridOffset} {
                width: 100%;
                margin: 0px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;                   
                > ${GridItemStyle} {
                    justify-content: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position:relative;
                    &:first-child{
                        max-width:115px;
                        text-align:center;
                        > ${GridItemStyle} {
                            width: 100%;
                            max-width: 100%;
                            padding: 0;
                            &:first-child{
                                > ${TypographyStyle} {
                                    color: #2D2926;
                                    text-align: center;
                                    line-height: 24px;
        
                                    &:first-child{
                                        font-size: 14px;
                                        font-weight: 400;
                                        margin-bottom: 6px;    
                                    }
                                    &:last-child{
                                        font-size: 20px;
                                        font-weight: 700;
                                        margin-bottom: 20px;    
                                        line-height: 34px; 
                                    }
                                }    
                            }
                            &:last-child{
                                > ${TypographyStyle} {
                                    color: #666;
                                    text-align: center;
                                    line-height: 24px;
                                    
                                    &:first-child{
                                        font-size: 14px;
                                        font-weight: 400;
                                        margin-bottom: 6px; 
                                    }
                                    &:last-child{
                                        margin-bottom: 0px;    
                                        line-height: 34px;
                                        font-size: 20px;
                                        font-weight: 700;
                                    }
                                }
        
                            }
        
                        }
                    }
                    &:last-child{
                        max-width:160px;
                    }
                    
                    
                }
                }
            `,
        },
        loyaltyContainerModal: {
            css: css`                               
            justify-content: center;
            align-items: flex-start;
            display: flex;
            flex-direction:column;
            padding: 25px 0px 15px 0px;
            margin-bottom: 0px;
            >  ${GridOffset} {
                margin: 0;
                padding: 0;
                width:100%;
                > ${GridItemStyle} {
                    padding: 0;
                    justify-content: center;
                    align-items:center;
                    flex-direction:column;
                    > ${GridItemStyle} {
                        width: 100%;
                        margin: 0px;
                        padding: 0;
                        max-width: 100%;
                        justify-content: center;
                        &.loyaltymypoints{
                            padding-bottom: 15px;
                            margin: 0px 20px 15px 20px;
                            border-bottom: 1px solid #bbb;
                            width: calc(100% - 40px);                            
                            h5{
                                margin-bottom:0px;
                                color: #002856;
                                font-size: 20px;
                                font-weight: 700;
                                line-height: 28px;
                                
                            }
                        }
                        &:nth-child(2){
                            > ${GridItemStyle} {
                                flex-direction:column;
                                padding: 0;
                                justify-content: center;
                                align-items: center;
                                ${TypographyStyle}{
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin-bottom: 5px;
                                    line-height: normal;
                                    &:last-child{
                                        font-weight: 800;
                                        margin-bottom: 0px;
                                        font-size: 18px;
                                    }
                                }                                
                            }
                        }
                    }                      
                }          
            }
        }   
        .reedeembtn{
        border-top: 1px solid #bbb;
        background: #f7f7f7;
        height: 100% !important;
        margin-top: 65px !important;
        padding: 25px 20px 30px !important;
        @media (max-width: 767px) {
               margin-bottom:50px !important;
            }
        }                      
    `,
        },
        loyaltyAvailPointsText: {
            css: css`
            color: #2d2926;
            `,
        },
        loyaltyPendPointsText: {
            css: css`
            color: #666;
            `,
        },
        loyaltySeedetailBtn: {
            css: css`
            color: #000;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            cursor: pointer;
            line-height: normal;
            margin-top: 25px;
            justify-content: center;
            &:hover{
                text-decoration:underline;
            }
            `,
        },
        leftColumnModalGrid: {
            css: css`
            max-width:110px;
            padding:0px;
            `,
        },
        titleGridItemModal: {
            css: css`
            width: 100%;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: 700;
            line-height: 26px;
            color: #002856;
            `,
        },
        loyaltyLabelTextModal: {
            css: css`
            font-size: 14px;
            font-weight: 400;
            text-align: center;           
            `,
        },
        loyaltyValueTextModal: {
            css: css`
            font-size: 20px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 18px;
            `,
        },
        loyaltygoalValueTextModal: {
            css: css`
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 0px;
            &:after{
                content: '%';
                font-weight: 400;
            }
            `,
        },
        loyaltyProgressModal: {
            css: css`
            margin-top:20px;
            margin-bottom:20px;
            `,
        },
        hideElementsMob: {
            css: css`
            
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, null, css` display:none; `,], "max",);
                }} 
            `,
        },

        loyaltyTotalSpend: {
            css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom:20px;
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` flex-basis: 40%;
                text-align: center;
                margin-bottom:0px; `,], "max",);
                }} 
            
            `,
        },
        loyaltyRemainingSpend: {
            css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            
            ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [null, css` flex-basis: 60%;               
                        text-align: center;`,], "max",);
                }} 
            `,
        },
        rewardsInfoIconNotes: {
            css: css`
            position:absolute;
            width: 22px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` margin-top: 10px; `, null, css`margin-top: 20px;`],);
            }} 

            `,
        },
        rewardsInfoIconhide: {
            css: css`
            display:none;
            `,
        },
        rewardsInfoIconPending: {
            css: css`
            position: relative;
            width: 22px;
            height: 22px;
            display: inline-block;
            margin-right: 6px;
            float: left;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css`position: absolute !important;top: -3px;left: -28px; `, null, css`margin-top: 0px;`],);
            }} 
            `,
        },
        loyaltymypointsContainer:{
            css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css`padding-left:22px !important; `,css`padding-left:22px !important; `, null,null,null,],);
            }} 
            `,
        },
        rightColumnAppsend : {
            css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null,null,null,null,css`width:74%!important;margin:0 auto; `,],);
            }} 
            `,
        },
        
        
    },
};